export default {
  tableBlock: {
    marginTop: 20,
  },
  transferButton: {
    marginTop: 15,
  },
};
